import { string } from "prop-types";

const AmsterdamWest = ({ className }) => (
  <path
    d="M562.512 214.96L542.609 186.055L534.731 193.9H520.634L501.561 202.985L491.609 192.249L484.146 191.638V222.418L442.268 222.393L442.475 236.845H425.617L426.098 255.015L412 293.83L433.561 301.263L432.732 316.129H452.634L458.439 330.383V354.119H454.293V367.39H472.445V376.83H479.585L526.024 357.009H538.944L550.073 349.576L528.512 300.024L562.512 214.96Z"
    fill="url(#paint1_linear_14735_232327)"
    fillOpacity="0.25"
    stroke="#4D4D4D"
    strokeWidth="2"
    strokeMiterlimit="10"
    strokeDasharray="4 4"
    className={className}
  />
);

AmsterdamWest.propTypes = {
  className: string,
};

export default AmsterdamWest;
